<template>
	<div class="chat-cluster-member-shadow">
		<div class="chat-cluster-member">
			<div class="chat-cluster-member-wrap">
				<div class="chat-cluster-member-header">
					<div class="chat-cluster-member-title">{{comTitle}}</div>
					<div class="chat-cluster-member-h-opts">
						<span @click="close">关闭</span>
					</div>
				</div>
				<div class="chat-cluster-member-box">
					<form class="layui-form" action="">
						<div class="chat-cluster-member-item" v-if="optType === 'create'">
						  <label class="layui-form-label"><i class="layui-icon">&#xe770;</i>客服选择</label>
						  <div class="chat-cluster-member-block">
								<select lay-ignore v-model="selectCustomId">
									<option :value="custom.id" v-for="custom in customList">{{custom.wx_name}}-{{custom.identity}}</option>
								</select>		  
						  </div>
						</div>
						<div class="layui-form-item">
							<label class="layui-form-label"><i class="layui-icon">&#xe612;</i>粉丝选择</label>
							<div class="layui-input-block">
							   <div class="chat-cluster-member-fans-search" v-if="optType !== 'reduce'">
								   <input type="text" name="tag" v-model="tag" autocomplete="off" placeholder="请输入标签" class="layui-input">
								   <input type="text" name="name" v-model="name" autocomplete="off" placeholder="粉丝昵称" class="layui-input">
								   <input type="text" name="start_time" autocomplete="off" placeholder="粉丝时间" class="layui-input" id="create_time" style="width: 290px;display: none;">
								   <button class="layui-btn layui-btn-normal" type="button" @click="getFans">搜索</button>
							   </div>
							   <div class="chat-cluster-member-fans" id="fans-select"></div>
							</div>
						</div>
						<div class="layui-form-item">
							<div class="layui-input-block">
							  <button class="layui-btn" lay-submit lay-filter="submitFans">确认</button>
							  <button type="reset" class="layui-btn layui-btn-primary">清空</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getFansByCustomIdAndTag} from '../../../network/local/friend.js'
	
	export default{
		name:"CircleClusterMember",
		props:{
			comTitle:{
				type: String,
				default: '粉丝选择'
			},
			optType:{
				type: String,
				default: ''
			},
			customId:{
				type: Number,
				default: 0
			},
			fanList:{
				type: Array,
				default:[]
			},
			filterFanList:{
				type: Array,
				default:[]
			},
			customList:{
				type: Array,
				default:[]
			}
		},
		data(){
			return{
				tag: '',
				name: '',
				startTime: '',
				endTime: '',
				selectCustomId: 0,
				selectFans:[],
				transfer:null,
				from: null
				
			}
		},
		components:{
			
		},
		methods:{
			// 获取粉丝列表
			getFans(){
				switch(this.optType){
					// 创建新群
					case 'create':
						this.getCreateFans()
						break
					// 添加群成员
					case 'add':
						this.getAddFans()
						break
					// 删除群成员
					case 'reduce':
						this.getReduceFans()
						break
				}
			},
			
			// 获取新建群所需要的粉丝列表
			getCreateFans(){
				this.getAddFans(this.selectCustomId)
			},
			
			// 获取添加成员时的粉丝列表
			getAddFans(customId){
				let param = {
					tag: this.tag,
					name: this.name,
					startTime: this.startTime,
					endTime: this.endTime
				}
				if(customId === undefined || customId === 0){
					customId = this.customId
				}
				// 加载粉丝数据后重新渲染列表
				getFansByCustomIdAndTag(customId,param,data=>{
					let fans = []
					if(data.length > 0){
						for (let i = 0; i < data.length; i++) {
							if(this.filterFanList.indexOf(data[i].open_id) === -1){
								let title = (data[i].con_remark !== undefined && data[i].con_remark !== null && data[i].con_remark !== "") ? data[i].con_remark : data[i].wx_name
								fans.push({
									"value": data[i].open_id,
									"title": title,
									"disabled": "", 
									"checked": ""
								})
							}
						}
						
					}
					//可以重载所有基础参数
					this.transfer.reload('fans-select', {
						data: fans,
						value: this.selectFans
					});
				})
			},
			
			// 获取删除成员时的粉丝列表
			getReduceFans(){
				if(this.fanList.length > 0){
					let fans = []
					for (let i = 0; i < this.fanList.length; i++) {
						if(this.filterFanList.indexOf(this.fanList[i].open_id) === -1){
							fans.push({
								"value": this.fanList[i].open_id,
								"title": this.fanList[i].wx_name,
								"disabled": "", 
								"checked": ""
							})
						}
					}
					//可以重载所有基础参数
					this.transfer.reload('fans-select', {
						data: fans,
						value: this.selectFans
					});
				}
			},
			
			//关闭页面
			close(){
				this.$emit("close-option")
			}
		},
		mounted() {
			// 使用layui渲染表单页面
			let _this = this
			let form,transfer,laydate
			layui.use(['form','transfer','laydate'], function(){
			  form = layui.form
			  transfer = layui.transfer
			  let laydate = layui.laydate
			  
			  //监听提交
			  form.on('submit(submitFans)', function(data){
				  let backData = {
					  type: _this.optType,
					  list:_this.selectFans,
					  customId:_this.selectCustomId
				  }
				  _this.$emit('fans-select-call',backData)
			    return false;
			  })

			  // 穿梭树渲染
			  transfer.render({
				elem: '#fans-select'  ,//绑定元素
				title:['粉丝列表','已选粉丝列表'],
				showSearch:false,
				width:300,
				height: 400,
				data: [],
				value:[],
				showSearch:true,
				id: 'fans-select' ,//定义索引
				onchange:function(data,index){
					 //如果数据来自左边，index 为 0，否则为 1
					if(index === 0){
						for (let i = 0; i < data.length; i++) {
							if(_this.selectFans.indexOf(data[i].value) === -1){
								_this.selectFans.push(data[i].value)
							}
						}
					}else if(index === 1){
						for (let i = 0; i < data.length; i++) {
							let fansIndex = _this.selectFans.indexOf(data[i].value)
							if(fansIndex !== -1){
								_this.selectFans.splice(fansIndex,1)
							}
						}
					}
				}
			  })
			  
			  // 时间选择器-开始时间
			  laydate.render({
				 elem: '#create_time' ,//指定元素
				 type: 'datetime',
				 range: true,
				 done:function(value,date,endDate){
					if(value === undefined || value === ''){
						_this.startTime = ''
						_this.endTime = ''
					}else{
						let dateArr = value.split(' - ')
						if(dateArr.length === 2){
							_this.startTime = dateArr[0]
							_this.endTime = dateArr[1]
						}
					}
				 }
			  })
			  
			  // 默认将客服列表的第一个选中
			  if(_this.customList[0] !== undefined){
				   _this.selectCustomId = _this.customList[0].id
			  }
			  
			  _this.transfer = transfer
			  _this.from = form
			  _this.from.render()
			  _this.getFans()
			});
		},
		
		watch:{
			// 监听客服选择变化
			selectCustomId(nVal,oVal){
				if(oVal != 0){
					this.selectFans = []
					this.getFans()
				}
			}
		}
	}
</script>

<style>
	.chat-cluster-member-shadow{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #000000a1;
		padding: 50px 100px;
	}
	.chat-cluster-member{
		position: relative;
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
		box-sizing: border-box;
		max-width: 1300px;
		margin: 0 auto;
	}
	.chat-cluster-member-wrap{
		position: relative;
		width: 100%;
		height: 100%;
	}
	.chat-cluster-member-wrap .chat-cluster-member-header{
		height: 44px;
		line-height: 44px;
		border-bottom: 1px solid #eaeaea;
		padding: 0 20px;
		display: flex;
		justify-content: space-between;
		background-color: #eeeeee;
	}
	.chat-cluster-member-header .chat-cluster-member-h-opts span{
		cursor: pointer;
		display: inline-block;
		height: 34px;
		line-height: 34px;
		padding: 5px;
		user-select: none;
	}
	.chat-cluster-member-box{
		padding: 10px 20px;
	}
	.chat-cluster-member-fans-search{
		margin-bottom: 5px;
	}
	.chat-cluster-member-fans-search > *{
		display: inline-block;
		vertical-align: middle;
	}
	.chat-cluster-member-fans-search > input{
		margin-right: 5px;
	}
	.chat-cluster-member-fans-page{
		margin-top: 5px;
	}
	.chat-cluster-member-fans-page>.comp-page{
		justify-content: flex-start;
	}
	.layui-input{
		width: 148px;
	} 
	.layui-input:focus{
		border: 1px solid #42B983 !important;
	}
	.layui-form-label i{
		margin-right: 5px;
	}
	.chat-cluster-member-item{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 10px;
	}
	.chat-cluster-member-block{
		width: 0;
		flex-grow: 1;	
		height: 28px;
	}
	.chat-cluster-member-block>select{
		width: 292px;
		height: 28px;
		display: inline-block;
		border: 1px solid #CCCCCC;
		cursor: pointer;
		padding: 0 5px;
	}
</style>
